import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'instagramEmbeddedLink',
})
export class InstagramEmbeddedLinkPipe implements PipeTransform {
  transform(value: string): string {
    if (value.includes('embed')) {
      return value;
    }

    const imgIndex = value.indexOf('/?img_index=');
    if (imgIndex > 0) {
      const pathWithoutImgIndex = value.slice(0, imgIndex);
      return `${pathWithoutImgIndex}/embed`;
    }

    const utmIndex = value.indexOf('/?utm_source=');
    if (utmIndex > 0) {
      const pathWithoutUtm = value.slice(0, utmIndex);
      return `${pathWithoutUtm}/embed`;
    }

    if (value.length && value[value.length - 1] === '/') {
      return `${value}embed`;
    }

    return `${value}/embed`;
  }
}
